import React, { useMemo, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const LOOKUP_OPTIONS = [
    { value: 'ClubID', label: 'ClubID' },
    { value: 'ZoomSiteCode', label: 'Zoom Site Code' },
    { value: 'CustomerKey', label: 'Customer Key' },
];

// splits commas/newlines, trims, drops empties
function parseValues(text) {
    const raw = (text ?? '')
        .split(/[\n,]+/)
        .map(v => v.trim())
        .filter(Boolean);

    const seen = new Set();
    const out = [];
    for (const v of raw) {
        const k = v.toLowerCase();
        if (seen.has(k)) continue;
        seen.add(k);
        out.push(v);
    }
    return out;
}

export default function UploadUserEntitiesModal({
    show,
    onClose,
    onSubmit,      
    isSubmitting,  // boolean for disabling UI
}) {
    const [lookupType, setLookupType] = useState('ClubID');
    const [valuesText, setValuesText] = useState('');

    const values = useMemo(() => parseValues(valuesText), [valuesText]);
    const canSubmit = values.length > 0 && !isSubmitting;

    const handleSubmit = async () => {
        const valuesCsv = values.join(',');
        const ok = await onSubmit?.({ lookupType, valuesCsv });
        if (ok) {
            setValuesText('');
            setLookupType('ClubID');
        }
    };

    return (
        <Modal show={show} onHide={onClose} centered size="sm">
            <Modal.Header closeButton>
                <Modal.Title>Upload Clubs</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form.Group className="mb-3">
                    <Form.Label className="fw-bold">Lookup Type</Form.Label>
                    <Form.Select
                        value={lookupType}
                        onChange={(e) => setLookupType(e.target.value)}
                        disabled={isSubmitting}
                    >
                        {LOOKUP_OPTIONS.map(opt => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                    </Form.Select>
                </Form.Group>

                <Form.Group>
                    <Form.Label className="fw-bold">Comma-separated values</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={6}
                        placeholder="Example: 123, 456, 789"
                        value={valuesText}
                        onChange={(e) => setValuesText(e.target.value)}
                        disabled={isSubmitting}
                    />
                    <div className="mt-2 small text-muted">
                        {values.length} value(s) found
                    </div>
                </Form.Group>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onClose} disabled={isSubmitting}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit} disabled={!canSubmit}>
                    {isSubmitting ? 'Uploading…' : 'Upload'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}